import { useClient } from 'Data/Api.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useDataChange } from 'Simple/Data.js'
import query from './query-get-person-by-professional-relationship.graphql.js'

export function useOnSave(props) {
  let client = useClient()
  let change = useDataChange({
    context: 'picker',
    path: 'recipient_id',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSave(id) {
    let response = await client
      .query(query, { id }, { requestPolicy: 'network-only' })
      .toPromise()

    if (response.error) {
      console.error('Error fetching person:', response.error)
      return
    }

    change(
      response.data?.vaxiom_professional_relationships_by_pk?.other?.person?._id
    )
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
